import {ACTION_TYPES, createAction} from "../actions";
import {all, call, fork, put, takeEvery} from 'redux-saga/effects'
import {deleteLayerByType} from "../../http/deleteLayerByType";
import {requestEntitiesByLayerType} from "../../http/requestEntitiesByLayerType";
import {deleteEntityGenerator} from "./deleteEntity";
import {delay} from "redux-saga";
import {AnyAction} from "redux";

export function* deleteLayerSaga () {
    yield takeEvery(ACTION_TYPES.DELETE_LAYER, deleteLayer);
}

function* deleteLayer (action: any) {
    const payload: {layerId: string} = action.payload;
    try {
        const {layerId} = payload;
        const entitiesToDelete = yield call(requestEntitiesByLayerType, layerId) || [];
        if (entitiesToDelete.length > 0) {
            const entityActions = entitiesToDelete.map(({fullUid}: any) =>
                createAction(ACTION_TYPES.DELETE_ENTITY, {
                    fullUid, type: layerId
                })
            );

            const actions = [
                ...entityActions.map((action: AnyAction) => fork(deleteEntityGenerator, action))
            ];
            yield all(actions);
            // rerun action after deleting entities;
            // TODO: maybe a better approach
            yield delay(1000);
            yield put(createAction(ACTION_TYPES.DELETE_LAYER, action.payload));
        } else {
            const {type} = yield call(deleteLayerByType, layerId);
            yield put(createAction(ACTION_TYPES.DELETE_LAYER_SUCCESS, {
                layerId, type
            }));
        }
    } catch (error) {
        yield put(createAction(ACTION_TYPES.DELETE_LAYER_ERROR, {error}));
    }
}
